import React from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../assests/leftArrow.svg";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Checkbox,
  Typography,
  IconButton,
  Popover
} from "@mui/material";
import { Visibility, FilterList } from "@mui/icons-material";
import LoadingSpinner from "../../Loading/component";
import successicon from "../../../assests/success.svg"
import './uidDashboard.css';
import ListOfCreatedUid from './ListOfcreatedUids/ListofCreatedUids';
import BulkQRCodeGenerator from './BulkQRCodeGenerator';
import CloseIcon from '@mui/icons-material/Close';

const VmIdDashboardComponent = ({
  uids,
  loading,
  error,
  searchTerm,
  currentPage,
  hasMore,

  showSuccessDialog,
  createdUids,
  showErrorDialog,
  errorMessage,
  createUidOpen,
  apiLoading,
  showListPage,

  showBulkQRDialog,
  qrUids,
  pdfDownloading,
  setShowBulkQRDialog,

  statusFilter,
  mappingStateFilter,
  statusFilterAnchorEl,
  mappingFilterAnchorEl,
  statusOptions,
  mappingStateOptions,

  selectedUids,
  selectAll,

  newUidData,

  navigate,

  setSearchTerm,
  onLoadNextPage,
  handleCreateUid,
  handleCloseCreateUid,
  handleCreateUidSubmit,
  handleBulkUpload,
  handleInputChange,
  handleUidSelect,
  handleSelectAll,
  isUidSelected,
  handleDownloadSelected,
  handleViewDetails,
  handleStatusFilterClick,
  handleMappingFilterClick,
  handleStatusFilterChange,
  handleMappingStateFilterChange,
  handleClearFilters,
  handleBackFromList,
  onCloseSuccessDialog,
  onCloseErrorDialog,
  onPDFDownloadComplete,
  formatDate,
  onDownloadAndRedirect

}) => {

  const handleViewDetailsWithRouting = (uid) => {
    if (uid.mappingState === 'Mapped') {
      navigate(`/uid-unmap/${uid.uid || uid.uid}`);
    } else if (uid.mappingState === 'Unmapped') {
      navigate(`/uid-map/${uid.uid || uid.uid}`);
    } else {
      handleViewDetails(uid);
    }
  };

  // Handle key press to prevent decimal input
  const handleKeyPress = (e) => {
    // Prevent decimal point, minus, plus, and 'e' (scientific notation)
    if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
  };

  // Handle paste to remove non-digit characters
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    // Remove any non-digit characters from pasted text
    const cleanText = pastedText.replace(/[^\d]/g, '');
    // Remove leading zeros
    const finalText = cleanText.replace(/^0+/, '') || '';
    handleInputChange('uid', finalText);
  };

  // Apply filters locally in component
  const getFilteredUids = () => {
    return uids.filter(uid => {
      const statusMatch = statusFilter === 'all' || 
        (uid.status?.toString().toLowerCase() === statusFilter.toLowerCase());
      
      const mappingStateMatch = mappingStateFilter === 'all' || 
        (uid.mappingState?.toLowerCase() === mappingStateFilter.toLowerCase());
      
      return statusMatch && mappingStateMatch;
    });
  };

  const filteredUids = getFilteredUids();

  // Success Dialog Component
  const SuccessDialog = () => (
    <Dialog open={showSuccessDialog} maxWidth="sm" fullWidth style={{ width: "450px", margin: "auto" }}>
      <DialogTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: "center", flexDirection: "column" }}>
          <img src={successicon} alt="" style={{ width: 58, height: 58 }} />
          <Typography className='success-main-title'>Successfully</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="uid-success-dialog-content">
          <p>{createdUids.length} New UID(s) Created Successfully</p>
          <p style={{ fontSize: '14px', color: '#666', marginTop: '8px' }}>
            Click the button below to download CSV and QR codes PDF, and view the created UIDs.
          </p>
        </div>
      </DialogContent>
      <DialogActions className='action-btn'>
        <Button variant='outlined' onClick={onCloseSuccessDialog} className="success-ok-btn">
          OK
        </Button>
        <Button
          onClick={onDownloadAndRedirect}
          className="success-download-btn"
          variant="contained"
        >
          Download CSV & QR PDF
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Error Dialog Component
  const ErrorDialog = () => (
    <Dialog
      open={showErrorDialog}
      onClose={onCloseErrorDialog}
      maxWidth="sm"
      fullWidth
      className="uid-error-dialog"
    >
      <DialogTitle className="uid-error-dialog-title">
        <div className="error-dialog-header">
          <div className="error-icon">⚠️</div>
          <div className="error-title-content">
            <div className="error-main-title">Error</div>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="error-message">
          {errorMessage || 'An error occurred while processing your request.'}
        </div>
      </DialogContent>
      <DialogActions className="uid-error-dialog-actions">
        <Button
          onClick={onCloseErrorDialog}
          className="error-ok-btn"
          variant="contained"
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Status Filter Popover Component
  const StatusFilterPopover = () => (
    <Popover
      id="status-filter-popover"
      open={Boolean(statusFilterAnchorEl)}
      anchorEl={statusFilterAnchorEl}
      onClose={() => handleStatusFilterClick(null)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          padding: '15px',
          minWidth: '200px',
        }
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div style={{ fontWeight: 'bold' }}>Filter by Status</div>
        <IconButton 
          size="small" 
          onClick={() => handleStatusFilterClick(null)}
          style={{ padding: '2px' }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      {/* Clickable Filter List */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {statusOptions.map((option) => (
          <div
            key={option}
            onClick={() => {
              handleStatusFilterChange(option);
              handleStatusFilterClick(null); // Auto-close after selection
            }}
            style={{
              padding: '8px 10px',
              borderRadius: '6px',
              cursor: 'pointer',
              backgroundColor: statusFilter === option ? '#FFEEE0' : '#f9f9f9',
              color: statusFilter === option ? '#FF7A00' : '#333',
              fontWeight: statusFilter === option ? '600' : '400',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFF4E6'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = statusFilter === option ? '#FFEEE0' : '#f9f9f9'}
          >
            {option}
          </div>
        ))}
      </div>

      {/* Reset Button */}
      <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          onClick={() => {
            handleStatusFilterChange('all');
            handleStatusFilterClick(null); // Auto-close after reset
          }}
          variant="outlined" 
          size="small"
          disabled={statusFilter === 'all'}
        >
          Reset
        </Button>
      </div>
    </Popover>
  );

  // Mapping State Filter Popover Component
  const MappingFilterPopover = () => (
    <Popover
      id="mapping-filter-popover"
      open={Boolean(mappingFilterAnchorEl)}
      anchorEl={mappingFilterAnchorEl}
      onClose={() => handleMappingFilterClick(null)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          padding: '15px',
          minWidth: '200px',
        }
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div style={{ fontWeight: 'bold' }}>Filter by Mapping State</div>
        <IconButton 
          size="small" 
          onClick={() => handleMappingFilterClick(null)}
          style={{ padding: '2px' }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      {/* Clickable Filter List */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {mappingStateOptions.map((option) => (
          <div
            key={option}
            onClick={() => {
              handleMappingStateFilterChange(option);
              handleMappingFilterClick(null); // Auto-close after selection
            }}
            style={{
              padding: '8px 10px',
              borderRadius: '6px',
              cursor: 'pointer',
              backgroundColor: mappingStateFilter === option ? '#FFEEE0' : '#f9f9f9',
              color: mappingStateFilter === option ? '#FF7A00' : '#333',
              fontWeight: mappingStateFilter === option ? '600' : '400',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFF4E6'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = mappingStateFilter === option ? '#FFEEE0' : '#f9f9f9'}
          >
            {option}
          </div>
        ))}
      </div>

      {/* Reset Button */}
      <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          onClick={() => {
            handleMappingStateFilterChange('all');
            handleMappingFilterClick(null); // Auto-close after reset
          }}
          variant="outlined" 
          size="small"
          disabled={mappingStateFilter === 'all'}
        >
          Reset
        </Button>
      </div>
    </Popover>
  );

  // If showListPage is true, render the ListOfCreatedUid component
  if (showListPage) {
    return (
      <ListOfCreatedUid
        createdUids={createdUids}
        onBack={handleBackFromList}
        onStartPDFDownload={onDownloadAndRedirect}
        pdfDownloading={pdfDownloading}
        onPDFDownloadComplete={onPDFDownloadComplete}
      />
    );
  }

  // Main Dashboard UI
  return (
    <div className="uid-dashboard-container">
      {/* Full page loader overlay */}
      {loading && currentPage === 0 && (
        <div className="uid-full-page-loader">
          <LoadingSpinner />
        </div>
      )}

      <Sidebar />
      <div className="uid-dashboard-content">
        {/* Header Section */}
        <div className="uid-header-section">
          <Button
            className="uid-back-button"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <img src={leftArrow} alt="Back" />
          </Button>
          <h1 className="uid-main-title">VMID's Dashboard</h1>
        </div>

        {/* Search and Actions Section */}
        <div className="uid-search-actions-section">
          <div className="uid-search-container">
            <div className="uid-search-input-container">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="uid-search-input"
              />
            </div>
          </div>

          <div className="uid-actions-container-main">
            <Button
              variant="outlined"
              className="uid-create-btn"
              onClick={handleCreateUid}
              disabled={apiLoading}
            >
              {apiLoading ? <CircularProgress size={20} /> : 'Create UID'}
            </Button>
            <Button
              variant="outlined"
              className="uid-bulk-btn"
              onClick={handleBulkUpload}

            >
              Bulk Upload
            </Button>
            <Button
              className="uid-download-btn"
              onClick={handleDownloadSelected}
              disabled={selectedUids.size === 0}
              startIcon={
                <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                </svg>
              }
            >
              ({selectedUids.size})
            </Button>
          </div>
        </div>

        {/* UID Table Section */}
        <div className="uid-table-section">
          <div className="uid-table-container">
            <table className="uid-main-table">
              <thead>
                <tr>
                  <th className="uid-table-checkbox">
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                      indeterminate={selectedUids.size > 0 && selectedUids.size < filteredUids.length}
                    />
                  </th>
                  <th className="uid-table-header">S.No.</th>
                  <th className="uid-table-header">UID</th>
                  <th className="uid-table-header">VMID</th>
                  <th className="uid-table-header">VM Name</th>
                  <th className="uid-info-header">Last Update</th>
                  <th className="uid-info-header">
                    <div className="filter-header-cell">
                      Status
                      <IconButton
                        className="uid-filter-button header-filter-btn"
                        onClick={handleStatusFilterClick}
                        aria-label="Filter Status"
                        size="small"
                        style={{ 
                          color: statusFilter !== 'all' ? '#1976d2' : 'inherit'
                        }}
                      >
                        <FilterList fontSize="small" />
                      </IconButton>
                    </div>
                  </th>
                  <th className="uid-info-header">
                    <div className="filter-header-cell">
                      Mapping State
                      <IconButton
                        className="uid-filter-button header-filter-btn"
                        onClick={handleMappingFilterClick}
                        aria-label="Filter Mapping State"
                        size="small"
                        style={{ 
                          color: mappingStateFilter !== 'all' ? '#1976d2' : 'inherit'
                        }}
                      >
                        <FilterList fontSize="small" />
                      </IconButton>
                    </div>
                  </th>
                  <th className="uid-info-header">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUids.length > 0 ? (
                  filteredUids.map((uid, index) => (
                    <tr key={uid.id || `${uid.uid}-${index}`} className="uid-table-row">
                      <td className="uid-table-checkbox">
                        <Checkbox
                          checked={isUidSelected(uid.uid)}
                          onChange={() => handleUidSelect(uid.uid)}
                        />
                      </td>
                      <td className="uid-table-sno">{index + 1}</td>
                      <td className="uid-table-uid">{uid.uid || 'N/A'}</td>
                      <td className="uid-table-vmid">{uid.vmId || 'N/A'}</td>
                      <td className="uid-table-vmname">{uid.vmName || 'N/A'}</td>
                      <td className="uid-date-cell">
                        {formatDate(uid.lastUpdatedAt)}
                      </td>
                      <td className="uid-status-cell">
                        <span>{uid.status || 'N/A'}</span>
                      </td>
                      <td className="uid-mapping-cell">
                        <span className={`uid-mapping-badge uid-mapping-${uid.mappingState?.toLowerCase() || 'unknown'}`}>
                          {uid.mappingState || 'N/A'}
                        </span>
                      </td>
                      <td className="uid-actions-cell">
                        <div className="uid-actions-container">
                          <IconButton
                            className="uid-view-btn"
                            onClick={() => handleViewDetailsWithRouting(uid)}
                            size="small"
                            title={`View Details`}
                          >
                            <Visibility />
                          </IconButton>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  !loading && (
                    <tr>
                      <td colSpan="9" className="uid-no-data">
                        No UIDs found
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>

            {/* Load More Button */}
            {hasMore && filteredUids.length > 0 && (
              <div className="uid-load-more-container">
                <Button
                  variant="outlined"
                  onClick={onLoadNextPage}
                  disabled={loading}
                  className="uid-load-more-btn"
                >
                  {loading ? <CircularProgress size={20} /> : 'Load More'}
                </Button>
              </div>
            )}
          </div>
        </div>

        {/* Create UID Dialog */}
        <Dialog
          open={createUidOpen}
          maxWidth="sm"
          fullWidth
          className="uid-create-dialog"
        >
          <DialogTitle className="uid-dialog-title">
            Create UID
          </DialogTitle>
          <DialogContent className="uid-dialog-content">
            <div className="uid-form-container">
              <TextField
                label="Enter The Count Of UIDs To Create *"
                value={newUidData.uid}
                onChange={(e) => handleInputChange('uid', e.target.value)}
                onKeyPress={handleKeyPress} // Prevent decimal input
                onPaste={handlePaste} // Clean pasted content
                fullWidth
                margin="normal"
                className="uid-form-field"
                placeholder="Max 100 Numbers can be created at once"
                type="text" // Use text type to have full control
                inputProps={{
                  inputMode: 'numeric', // Shows numeric keyboard on mobile
                  pattern: '[0-9]*', // HTML5 pattern for numbers only
                  maxLength: 3 // Limit to 3 digits (max 100)
                }}
                helperText="Enter a number between 1 and 100"
              />
            </div>
          </DialogContent>
          <DialogActions className="uid-dialog-actions">
            <Button onClick={handleCloseCreateUid} className="uid-cancel-btn" disabled={apiLoading}>
              Cancel
            </Button>
            <Button onClick={handleCreateUidSubmit} className="uid-create-submit-btn" disabled={apiLoading}>
              {apiLoading ? <CircularProgress size={20} /> : 'Create UID'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Success Dialog */}
        <SuccessDialog />

        {/* Error Dialog */}
        <ErrorDialog />

        {/* Bulk QR Code Generator */}
        <BulkQRCodeGenerator
          open={showBulkQRDialog}
          onClose={() => setShowBulkQRDialog(false)}
          uids={qrUids}
          pdfDownloading={pdfDownloading}
          onPDFDownloadComplete={onPDFDownloadComplete}
        />

        {/* Filter Popovers */}
        <StatusFilterPopover />
        <MappingFilterPopover />
      </div>
    </div>
  );
};

export default VmIdDashboardComponent;